import { useCallback, useEffect, useState } from 'react'
import type { Unit } from './types'

function useUnits(uuid?: string | undefined) {
	const [units, setUnits] = useState<Unit[]>([])

	const [loading, setLoading] = useState<boolean>(false)
	const [error, setError] = useState<string | null>(null)

	const doQuery = useCallback(async () => {
		//if (!uuid) return
		setLoading(true)
		setError(null)
		let data: Unit[] = []

		try {
			const response = { ok: true } //await _getUnits(uuid)

			if (response && response.ok) {
				//const res = await response.json()
				//data = res.units
				data = [
					{
						uuid: 'UUID',
						language: 'FI',
						unit: 'kpl',
					},
				]
			} else {
				throw new Error('Response is not ok.')
			}
		} catch (err) {
			console.error('Error fetching Units:', err)
			setError('An error occurred while fetching Units: ' + uuid)
		}
		setUnits(data)
		setLoading(false)
	}, [uuid])

	useEffect(() => {
		doQuery()
	}, [doQuery])

	return {
		units,
		loading,
		error,
		refresh: doQuery,
	}
}

export type useUnitsResult = ReturnType<typeof useUnits>

export default useUnits
